// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"173":"cffe4e03","869":"126ea3e6"}[chunkId] + ".chunk.css";
};